const TOKEN_KEY = "wecommend_admin_token";
const EMAIL_KEY = "wecommend_admin_email";

export const tokenStore = {
  getToken(): string {
    return localStorage.getItem(TOKEN_KEY) ?? "";
  },
  setToken(token: string): void {
    localStorage.setItem(TOKEN_KEY, token);
  },
  clearToken(): void {
    localStorage.removeItem(TOKEN_KEY);
  },
  getEmail(): string {
    return localStorage.getItem(EMAIL_KEY) ?? "";
  },
  setEmail(email: string): void {
    localStorage.setItem(EMAIL_KEY, email);
  },
  clearEmail(): void {
    localStorage.removeItem(EMAIL_KEY);
  },
  clear(): void {
    this.clearToken();
    this.clearEmail();
  }
};
